<form (ngSubmit)="onSubmit()">
  <mat-form-field>
    <input
      matInput
      placeholder="Title"
      [(ngModel)]="title"
      name="title"
      required
    />
  </mat-form-field>

  <mat-form-field>
    <input
      matInput
      placeholder="Protocol Link"
      [(ngModel)]="protocolLink"
      name="protocolLink"
      required
    />
  </mat-form-field>

  <button mat-raised-button color="primary" type="submit">Create</button>
</form>
